import { Box, Button, IconButton, Stack, Typography, styled } from '@mui/material';
import { InfoOutlined } from '@mui/icons-material';

export const ErrorDialog = styled(Box)(({ theme }) => ({
  position: 'fixed',
  top: '50%',
  left: '50%',
  zIndex: theme.zIndex.globalError,
  transform: 'translate(-50%, -50%)',
  backgroundColor: theme.palette.error.main,
  padding: theme.spacing(2),
  borderRadius: theme.shape.borderRadius,
}));

export const ErrorRow = styled(Stack)({});

export const ErrorInfoIcon = styled(InfoOutlined)(({ theme }) => ({
  alignSelf: 'flex-start',
  color: theme.palette.primary.contrastText,
}));

export const ErrorMessage = styled(Typography)(({ theme }) => ({
  flex: 1,
  textAlign: 'center',
  color: theme.palette.primary.contrastText,
  whiteSpace: 'pre-line',
  paddingLeft: theme.spacing(1.25),
  paddingRight: theme.spacing(1.25),
  paddingBottom: theme.spacing(0.625),
}));

export const ErrorCloseButton = styled(IconButton)(({ theme }) => ({
  alignSelf: 'flex-start',
  color: theme.palette.primary.contrastText,
  padding: 0,
}));

export const ErrorRetryButton = styled(Button)(({ theme }) => ({
  display: 'block',
  marginLeft: 'auto',
  marginRight: 'auto',
  marginTop: theme.spacing(1),
  color: theme.palette.error.main,
  backgroundColor: theme.palette.primary.contrastText,
  '&:hover': {
    backgroundColor: theme.palette.primary.contrastText,
    filter: 'brightness(0.95)',
  },
}));
